import Header from "../components/header/Header";
import {Outlet, Route} from "react-router-dom";
import HomePage, {homePageLoader} from "../views/home-page/HomePage";
import SearchResults, {searchResultsLoader} from "../views/search/SearchResults";
import RecipeView, {recipeLoader} from "../views/recipe/RecipeView";
import NotFound, {notFoundLoader, NotFoundLoaderless} from "../views/NotFound";
import Create from "../views/create/Create";
import {useState} from "react";

const BaseLayout = ({children}) => {
    // const [isVertical, setIsVertical] = useState(window.innerWidth < window.innerHeight)
    const [isVertical, setIsVertical] = useState(false)

  return (
    <>
      <Header isVertical={isVertical} />
      <div className='gutters-2x'>
        {children}
      </div>
    </>
  )
}

export default (
  <Route
    element={
      <BaseLayout>
        <Outlet/>
      </BaseLayout>
    }
    errorElement={
      <BaseLayout>
        <NotFoundLoaderless/>
      </BaseLayout>
    }
  >

    <Route path='/' element={<HomePage/>} loader={homePageLoader}/>
    <Route path='/create' element={<Create/>}/>
    <Route path='/recipe/:name' element={<RecipeView/>} loader={recipeLoader}/>
    <Route path='/search' element={<SearchResults/>} loader={searchResultsLoader}/>
    <Route path='*' element={<NotFound/>} loader={notFoundLoader}/>
  </Route>
)
